<template>
	<div class="site">
		<Nav :blogName="siteInfo.blogName" :categoryList="categoryList" />

		<div class="m-mobile-hide">
			<Header v-if="$route.name === 'home'" />
		</div>

		<div class="main">
			<div class="m-padded-tb-big">
				<div class="ui container">
					<div class="ui stackable grid">
						<div class="three wide column m-mobile-hide" v-if="!isMomentsRoute">
							<Introduction :class="{'m-display-none': focusMode}" />
						</div>

						<div class="column" :class="isMomentsRoute ? 'sixteen wide' : 'ten wide'">
							<keep-alive include="Home">
								<router-view />
							</keep-alive>
						</div>

						<div class="three wide column m-mobile-hide" v-if="!isMomentsRoute">
							<RandomBlog :randomBlogList="randomBlogList" :class="{'m-display-none': focusMode}" />
							<Tags :tagList="tagList" :class="{'m-display-none': focusMode}" />
							<Tocbot v-if="$route.name === 'blog'" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<BlogPasswordDialog />

		<div class="m-mobile-hide">
			<meting-js
				v-if="siteInfo.playlistServer && siteInfo.playlistId"
				:server="siteInfo.playlistServer"
				:id="siteInfo.playlistId"
				type="playlist"
				fixed="true"
				theme="#25CCF7" />
		</div>

		<el-backtop style="box-shadow: none; background: none; z-index: 9999;">
			<img src="/img/paper-plane.png" style="width: 40px; height: 40px;">
		</el-backtop>

		<Footer :siteInfo="siteInfo" :badges="badges" :newBlogList="newBlogList" :hitokoto="hitokoto" />
	</div>
</template>

<script>
import {getHitokoto, getSite} from '@/api/index'
import Nav from '@/components/index/Nav'
import Header from '@/components/index/Header'
import Footer from '@/components/index/Footer'
import Introduction from '@/components/sidebar/Introduction'
import Tags from '@/components/sidebar/Tags'
import RandomBlog from '@/components/sidebar/RandomBlog'
import Tocbot from '@/components/sidebar/Tocbot'
import BlogPasswordDialog from '@/components/index/BlogPasswordDialog'
import {mapState} from 'vuex'
import {SAVE_CLIENT_SIZE, SAVE_INTRODUCTION, SAVE_SITE_INFO, RESTORE_COMMENT_FORM} from '@/store/mutations-types'

export default {
	name: 'Index',
	components: {
		Header,
		BlogPasswordDialog,
		Tocbot,
		RandomBlog,
		Tags,
		Nav,
		Footer,
		Introduction
	},
	data() {
		return {
			siteInfo: {
				blogName: '',
				webTitleSuffix: '',
				playlistServer: '',
				playlistId: ''
			},
			categoryList: [],
			tagList: [],
			randomBlogList: [],
			badges: [],
			newBlogList: [],
			hitokoto: {},
		}
	},
	computed: {
		...mapState(['focusMode']),
		isMomentsRoute() {
			return this.$route.name === 'moments'
		}
	},
	watch: {
		'$route.path'() {
			this.scrollToTop()
		}
	},
	created() {
		this.getSite()
		this.getHitokoto()
		this.$store.commit(RESTORE_COMMENT_FORM)
	},
	mounted() {
		this.$store.commit(SAVE_CLIENT_SIZE, {
			clientHeight: document.body.clientHeight,
			clientWidth: document.body.clientWidth
		})
		window.onresize = () => {
			this.$store.commit(SAVE_CLIENT_SIZE, {
				clientHeight: document.body.clientHeight,
				clientWidth: document.body.clientWidth
			})
		}
	},
	methods: {
		getSite() {
			getSite().then(res => {
				if (res.code !== 200) {
					return
				}
				this.siteInfo = res.data.siteInfo
				this.badges = res.data.badges
				this.newBlogList = res.data.newBlogList
				this.categoryList = res.data.categoryList
				this.tagList = res.data.tagList
				this.randomBlogList = res.data.randomBlogList
				this.$store.commit(SAVE_SITE_INFO, this.siteInfo)
				this.$store.commit(SAVE_INTRODUCTION, res.data.introduction)
				document.title = this.$route.meta.title + this.siteInfo.webTitleSuffix
			})
		},
		getHitokoto() {
			getHitokoto().then(res => {
				this.hitokoto = res
			})
		}
	}
}
</script>

<style scoped>
.site {
	display: flex;
	min-height: 100vh;
	flex-direction: column;
}

.main {
	margin-top: 40px;
	flex: 1;
}

.main .ui.container {
	width: 1400px !important;
	margin-left: auto !important;
	margin-right: auto !important;
}

.ui.grid .three.column {
	padding: 0;
}

.ui.grid .ten.column {
	padding-top: 0;
}

.m-display-none {
	display: none !important;
}
</style>
